import { AxiosRequestHeaders } from 'axios';
import { FetchData } from 'InternalLibrary';
import { getProcessEnvUrl } from '../utils/getUrl';
import { getShiftedDatetimeHeader } from '../utils/shiftedDateTime';
import { LOGIN_ROUTE } from 'utils/constants';
import axiosInstance from '../utils/axiosInstance';

type OptionsMethod = 'get' | 'post' | 'put' | 'delete';

export const redirection401ToLogin = (
  message = 'errorMessage=session_expired',
) => {
  sessionStorage.clear();

  window.location.replace(`${LOGIN_ROUTE}?${message}`);
};

export const fetchData: FetchData = async (path, customOptions = {}) => {
  const defaultHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(sessionStorage.getItem('token') && {
      Authorization: `Basic ${sessionStorage.getItem('token')}`,
    }),
  };

  if (customOptions.body instanceof FormData) {
    // @ts-ignore
    delete defaultHeaders['Content-Type'];
  }

  const options = {
    ...customOptions,
    headers: {
      ...defaultHeaders,
      ...getShiftedDatetimeHeader(),
      ...customOptions.headers,
    },
  };

  const url = `${getProcessEnvUrl('WEB_API')}${path}`;

  const optionsMethod: OptionsMethod = (
    options.method || 'get'
  ).toLowerCase() as OptionsMethod;

  const responseAxios =
    optionsMethod === 'post' || optionsMethod === 'put'
      ? await axiosInstance[optionsMethod](url, options.body, {
          headers: options.headers as AxiosRequestHeaders,
        })
      : await axiosInstance[optionsMethod](url, {
          headers: options.headers as AxiosRequestHeaders,
        });

  return responseAxios.data;
};
